import { apiGet, apiPost, apiPut, appOrchidApiReq, thirdPartyApiGet, thirdPartyApiPost } from '@jumbo/utils/ApiHelper';
import config from 'config';
const loadApiUrl = config.loadApiUrl;
const carrierApiUrl = config.carrierApiUrl
const appOrchidUrl = config.appOrchidApiUrl;

export function getLoadsApi(data) {
  return apiGet(loadApiUrl, 'admin/loads', data);
}

export function getFiltersApi() {
  return apiGet(loadApiUrl, 'admin/loads/filters');
}

export function bookLoadApi(id, data) {
  return apiPost(loadApiUrl, `admin/loads/${id}/book`, data);
}

export function bidLoadApi(id, data) {
  return apiPost(loadApiUrl, `admin/loads/${id}/bid`, data);
}

export function getDocumentsApi(data) {
  return apiGet(loadApiUrl, 'admin/dispatches', data);
}

export function getDocumentsDetailsApi(id) {
  return apiGet(loadApiUrl, `admin/loads/dispatches/${id}`);
}

export function provideApprovalApi(id, data) {
  return apiPost(loadApiUrl, `admin/loads/${id}/documents/submit`, data);
}

export function bulkUploadApi(data) {
  return apiPost(loadApiUrl, 'admin/loads/bulk-upload', data);
}

export function getEquipmentsApi() {
  return apiGet(loadApiUrl, 'loads/equipments');
}

export function getInterestsApi(data) {
  return apiGet(loadApiUrl, 'admin/loads/interests', data);
}

export function getLoadsDetailsApi(id) {
  return apiGet(loadApiUrl, `admin/loads/${id}`);
}

export function editInterestsApi(id, data) {
  return apiPut(loadApiUrl, `admin/loads/interests/${id}`, data);
}

export function moveLoadsToRequestsApi(id, data) {
  return apiPost(loadApiUrl, `admin/loads/${id}/requests`, data);
}

export function getLanesApi(data) {
  return apiGet(loadApiUrl, 'admin/lanes', data);
}

export function createLanesApi(data) {
  return apiPost(loadApiUrl, 'admin/lanes', data);
}

export function editLaneApi(id, data) {
  return apiPut(loadApiUrl, `admin/lanes/${id}`, data);
}

export function approveOrRejectDocumentsApi(payload, dispatchId){
  return apiPost(loadApiUrl, `admin/loads/${dispatchId}/documents/submit`, payload)
}

export function getCarriersApi(data) {
  return apiGet(carrierApiUrl, 'admin/carriers', data);
  // return apiGet(loadApiUrl, 'loads/carriers/list', data)
}

export function getCarrierDetailsApi(id) {
  return apiGet(carrierApiUrl, `admin/carriers/${id}`);
}

export function getAppOrchidTokenApi(){
  let headers = {
    'Content-Type': 'application/json',
    Authorization: "None"
  }

  return thirdPartyApiPost(appOrchidUrl, `oauth/token?username=${config.appOrchidUsername}&password=${config.appOrchidPassword}&grant_type=password&scope=read%20write&client_secret=${config.appOrchidClientSecret}&client_id=${config.appOrchidClientId}`,{}, headers=headers)
}

export function getCarriersFromAppOrchidApi(data, token) {

  let headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`
  }
  return thirdPartyApiGet(appOrchidUrl, 'api/v1/carriers', data, headers)
}